module.exports = __webpack_public_path__ + "static/media/carousel-8.10ab4601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-8.jpg
// module id = 149
// module chunks = 1